import React from "react";
import ReactDOM from "react-dom";
import {Provider} from "react-redux";
import {createBrowserHistory} from "history";
import {ConnectedRouter} from "connected-react-router";
import {withRouter} from "react-router";

import {configureStore} from "./store";
import {reducers} from "./dependencies";
import App from "./dependencies";
import "./index.css";

const history = createBrowserHistory();
const AppWithRouter = withRouter(App);
export const store = configureStore({history, reducers});
const root = document.getElementById("root");
const Main = (
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <AppWithRouter/>
        </ConnectedRouter>
    </Provider>
);

ReactDOM.render(Main, root);
